<script setup>
import Prompt from './notifications/Prompt.vue';
import Alert from './notifications/Alert.vue';
import Confirm from './notifications/Confirm.vue';
import Conflict from './notifications/Conflict.vue';
import DualLanguageInput from './notifications/DualLanguageInput.vue';
import PotentialMistake from './notifications/PotentialMistake.vue';
import LinkToPageModal from './notifications/LinkToPageModal.vue';
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const showConflicts = computed(() => store.state.conflicts.filter(conflict => !conflict.hidden).length > 0);
</script>

<template>
    <DualLanguageInput v-for="dualLanguageInput in $store.state.dualLanguageInputs"
        :key="dualLanguageInput.id"
        v-show="!dualLanguageInput.hidden"
        :dualLanguageInput="dualLanguageInput"
        @close="dualLanguageInput.hidden = true"
        @save="dualLanguageInput.callback(dualLanguageInput.ja, dualLanguageInput.en, dualLanguageInput.anilistId)"
    />

    <Prompt v-for="prompt in $store.state.prompts"
        :key="prompt.id"
        v-show="!prompt.hidden"
        :prompt="prompt"
        @close="prompt.hidden = true"
        @save="prompt.callback(prompt.value)"
    />

    <Alert v-for="alert in $store.state.alerts"
        :key="alert.id"
        v-show="!alert.hidden"
        :alert="alert"
        @close="alert.hidden = true"
    />

    <Confirm v-for="confirm in $store.state.confirms"
        :key="confirm.id"
        v-show="!confirm.hidden"
        :confirm="confirm"
        @close="confirm.hidden = true"
        @ok="confirm.hidden = true && confirm.callback(true)"
        @cancel="confirm.hidden = true && confirm.callback(false)"
    />

    <Conflict
        v-if="showConflicts"
        :conflicts="$store.state.conflicts"
    />

    <PotentialMistake v-for="potentialMistake in $store.state.potentialMistakes"
        :key="potentialMistake.id"
        v-show="!potentialMistake.hidden"
        :potentialMistake="potentialMistake"
        :episode="potentialMistake.episode"
        @close="potentialMistake.hidden = true"
        @save="value => potentialMistake.callback(value)"
    />

    <LinkToPageModal v-for="modal in $store.state.linkToPageModals"
        :key="modal.id"
        v-show="!modal.hidden"
        :modal="modal"
        @close="modal.hidden = true"
        @save="staffData => { modal.hidden = true; modal.callback(staffData); }"
    />
</template>
